import axios from "@/api/axios";
import config from "@/config";
const account = {};
const base = config.api_base + "/account";
account.loginPage = (params)=>axios.post(base + "/login-page",params);
account.auth = (params)=>axios.post(base + "/auth",params);
account.info = (params)=>axios.post(base + "/info",params);
account.resetPassword = (params)=>axios.post(base + "/reset-password",params);

export default account;